import { GoLink } from "react-icons/go";
import { CopyToClipboard } from "@utils/copyToClipBoard";
import { type DataOSProps, type SingleServiceOrder, type Called } from "./interfaces";
import type { ServiceOrder } from "@interfaces/ServiceOrder";
import { useState, useEffect } from "react";
import { getInteractionsByCalledId } from "@service/serviceOrder";

//components
import { Accordion } from "@molecules";
import { Button } from "@atoms";
import { Interactions } from "@organisms/Interactions";

const renderSingleOrder = (
  ServiceOrder: SingleServiceOrder,
  goToInteractions: () => void,
  saveOs: (os: ServiceOrder) => void,
  goToConfirm: () => void,
  showInteractions: boolean,
  backToSearchPage: () => void
) => {
  const [called, setCalled] = useState<string>("");
  const [calledResponse, setCalledResponse] = useState<Called[]>([]);

  useEffect(() => {
    (async () => {
      const promises = ServiceOrder.chamados?.map(async (item) => {
        const response = await getInteractionsByCalledId(item.chamado.toString());
        return response.data.data as Called[];
      });

      if (promises) {
        const results = await Promise.all(promises);
        setCalledResponse(results.flat());
      }
    })();
  }, [ServiceOrder.chamados]);

  if (showInteractions) {
    return <Interactions backPage={backToSearchPage} calledId={called} />;
  }

  return (
    <Accordion Title={`OS - ${ServiceOrder.os.sua_os}`} isOS status={ServiceOrder.os.status ?? ""}>
      <div key={ServiceOrder.os.sua_os} className="mt-[15px]">
        <Accordion Title="Detalhes OS">
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D] text-right">Número da OS</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.os.sua_os}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Status</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.os.status}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Conta</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.nome}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Código do posto</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.posto.codigo_posto}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Tipo de atendimento</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.os.tipo_atendimento}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Fechado</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.os.fechado_em ? "Sim" : "Não"}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Dias desde status fechado</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.os.fechado_em}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Data de digitação</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.os.data_digitacao}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Data de entrada do posto</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.os.data_entrada_produto_posto}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Data do conserto</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.os.data_conserto}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Data da retirada do produto</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.os.data_retirada_produto_consumidor}
            </span>
          </p>
        </Accordion>
        <Accordion
          Title="Ordens reincidentes"
          hasReincident={ServiceOrder.os_reincidente.os_reincidente.length > 0}
        >
          {ServiceOrder.os_reincidente.os_reincidente.length > 0 ? (
            ServiceOrder.os_reincidente.os_reincidente.map((item) => (
              <p className="w-full flex justify-between text-[14px]">
                <span className="text-[#87929D]">Código da OS</span>
                <span className="text-end max-w-[70%]">{item}</span>
              </p>
            ))
          ) : (
            <p>Esta OS não possui reincidentes</p>
          )}
        </Accordion>
        <Accordion Title="Informações do produto">
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Produto</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.produto.descricao}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Aparência</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.produto.aparencia}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Informações sobre o defeito</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.produto.informacoes_sobre_defeito ?? "-"}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Defeito constatado</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.defeito.constatado}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Número de série</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.produto.serie}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Acessório</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.produto.acessorio}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Defeito reclamado</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.defeito.reclamado}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Solução</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.defeito.solucao}</span>
          </p>
        </Accordion>
        <Accordion Title="Informações da troca e ressarcimento">
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Responsável</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.troca_ressarcimento.responsavel ?? "-"}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Data</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.troca_ressarcimento.data ?? "-"}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Setor</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.troca_ressarcimento.setor ?? "-"}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Produto de troca</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.troca_ressarcimento.trocado_por ?? "-"}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Transporte</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.troca_ressarcimento.transporte ?? "-"}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Observação e troca</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.troca_ressarcimento.observacao === ""
                ? "-"
                : ServiceOrder.troca_ressarcimento.observacao}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Gera pedido</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.troca_ressarcimento.pedido ? "Sim" : "Não"}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Situação do atendimento</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.troca_ressarcimento.situacao_atendimento ?? "-"}
            </span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Motivo</span>
            <span className="text-end max-w-[70%]">
              {ServiceOrder.troca_ressarcimento.motivo ?? "-"}
            </span>
          </p>
        </Accordion>
        <Accordion Title="Informações de NF">
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Revendedora</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.revenda.nome}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">NF da revenda</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.revenda.nota_fiscal}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Data da compra</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.revenda.data_nota_fiscal}</span>
          </p>
        </Accordion>
        <Accordion Title="Informações do cliente">
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Nome do consumidor</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.nome}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Telefone</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.telefone}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Endereço</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.endereco}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Bairro</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.bairro}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Cidade</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.cidade}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">CPF integração</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.cpf}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Celular</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.celular}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">E-mail</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.email}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">Número do endereço</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.numero}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">CEP</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.cep}</span>
          </p>
          <p className="w-full flex justify-between text-[14px]">
            <span className="text-[#87929D]">UF</span>
            <span className="text-end max-w-[70%]">{ServiceOrder.consumidor.estado}</span>
          </p>
        </Accordion>
        <Accordion Title="Interações de auditoria">
          {ServiceOrder.intervencao ? (
            ServiceOrder.intervencao.map((item, index: number) => (
              <div
                className={
                  index === ServiceOrder.interacoes.length - 1 ? "" : "border-[#b0b8be] border-b"
                }
                key={index}
              >
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Data</span>
                  <span className="text-end max-w-[70%]">{item.data_intervencao}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Status</span>
                  <span className="text-end max-w-[70%]">{item.tipo_status_intervencao}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Admin</span>
                  <span className="text-end max-w-[70%]">{item.admin_intervencao}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">justificativa</span>
                  <span className="text-end max-w-[70%]">{item.justificativa}</span>
                </p>
              </div>
            ))
          ) : (
            <p>Sem intervenções</p>
          )}
        </Accordion>
        <Accordion Title="Peças">
          {ServiceOrder.peca ? (
            ServiceOrder.peca.map((item, index: number) => (
              <div
                className={
                  ServiceOrder.chamados && index === ServiceOrder.chamados.length - 1
                    ? ""
                    : "border-[#b0b8be] border-b"
                }
              >
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Componente</span>
                  <span className="text-end max-w-[70%]">{item.componente}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Quantidade</span>
                  <span className="text-end max-w-[70%]">{item.qtde}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Serviço</span>
                  <span className="text-end max-w-[70%]">{item.servico}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Pedido</span>
                  <span className="text-end max-w-[70%]">{item.pedido}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Nota fiscal</span>
                  <span className="text-end max-w-[70%]">{item.nota_fiscal}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Emissão</span>
                  <span className="text-end max-w-[70%]">{item.emissao}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">Defeito</span>
                  <span className="text-end max-w-[70%]">{item.defeito}</span>
                </p>
                <p className="w-full flex justify-between text-[14px]">
                  <span className="text-[#87929D]">NF Fabricante</span>
                  <span className="text-end max-w-[70%]">{item.nf_fabricante}</span>
                </p>
                <p className="w-full text-[14px]">
                  <span className="text-[#87929D]">OBS emissão</span>
                  <br />

                  <span className="text-left max-w-[70%] text-[12px]">
                    {item.obs_emissao === "" ? "-" : item.obs_emissao}
                  </span>
                </p>
              </div>
            ))
          ) : (
            <p>Nenhuma peça encontrada</p>
          )}
        </Accordion>
        <Accordion Title="Interações da OS">
          <div className="w-full">
            {ServiceOrder.interacoes && ServiceOrder.interacoes.length > 0 ? (
              ServiceOrder.interacoes.map((item, index) => (
                <div
                  className={
                    index === ServiceOrder.interacoes.length - 1 ? "" : "border-[#b0b8be] border-b"
                  }
                >
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Data</span>
                    <span className="text-end max-w-[70%]">{item.data}</span>
                  </p>
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Mensagem</span>
                    <span className="text-end max-w-[70%]">{item.mensagem}</span>
                  </p>
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Admin</span>
                    <span className="text-end max-w-[70%]">{item.admin}</span>
                  </p>
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Leitura</span>
                    <span className="text-end max-w-[70%]">{item.leitura}</span>
                  </p>
                </div>
              ))
            ) : (
              <p className="text-center font-[600]">Esta ordem de serviço não possui interações</p>
            )}
          </div>
        </Accordion>
        <Accordion Title="Chamados">
          <div className="w-full">
            {ServiceOrder.chamados ? (
              ServiceOrder.chamados.map((item, index) => (
                <div
                  className={
                    index === ServiceOrder.chamados.length - 1 ? "" : "border-[#b0b8be] border-b"
                  }
                >
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Chamado</span>
                    <span className="text-end max-w-[70%]">{item.chamado}</span>
                  </p>
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Status</span>
                    <span className="text-end max-w-[70%]">
                      {calledResponse[index]?.status ?? "-"}
                    </span>
                  </p>
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Tipo de solicitação</span>
                    <span className="text-end max-w-[70%]">
                      {calledResponse[index]?.tipo_solicitacao ?? "-"}
                    </span>
                  </p>
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Técnico responsável</span>
                    <span className="text-end max-w-[70%]">
                      {calledResponse[index]?.tecnico_responsavel ?? "-"}
                    </span>
                  </p>
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Responsavel pela solicitação</span>
                    <span className="text-end max-w-[70%]">
                      {calledResponse[index]?.responsavel_solicitacao ?? "-"}
                    </span>
                  </p>
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Pedido</span>
                    <span className="text-end max-w-[70%]">
                      {calledResponse[index]?.pedido ?? "-"}
                    </span>
                  </p>
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Data interação posto</span>
                    <span className="text-end max-w-[70%]">{item.data_ultima_interacao_posto}</span>
                  </p>
                  <p className="w-full flex justify-between text-[14px]">
                    <span className="text-[#87929D]">Data interação Admin</span>
                    <span className="text-end max-w-[70%]">
                      {item.data_ultima_interacao_admin ?? "-"}
                    </span>
                  </p>
                  <div className="text-center mb-[15px]">
                    <button
                      className="text-[blue] text-[14px] bg-[white] border-none cursor-pointer"
                      onClick={() => {
                        goToInteractions();
                        setCalled(item.chamado.toString());
                      }}
                    >
                      Ver interações
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-center font-[600]">Esta ordem de serviço não possui chamados</p>
            )}
          </div>
        </Accordion>

        <p className="text-[#293239]">Anexos</p>
        {ServiceOrder.anexos && ServiceOrder.anexos.length === 0 ? (
          <p className="text-[14px] text-[#293239] text-center">Sem anexos disponíveis.</p>
        ) : (
          <>
            {ServiceOrder.anexos ? (
              ServiceOrder.anexos.map((item) => (
                <div
                  key={item.link}
                  className="w-full h-[40px] flex items-center border border-[#b0b8be] mb-[10px] rounded-[5px]"
                >
                  <button
                    className="bg-[white] border-0 cursor-pointer"
                    onClick={() => {
                      CopyToClipboard(item.link);
                    }}
                  >
                    <GoLink className="mr-[15px] ml-[15px]" />
                  </button>
                  <p className="truncate max-w-[300px]">{item.link}</p>
                </div>
              ))
            ) : (
              <p className="w-full text-center">Nenhum anexo encontrado</p>
            )}
          </>
        )}
        <div className="my-[10px]">
          <Button
            onClick={() => {
              saveOs(ServiceOrder);
              goToConfirm();
            }}
            className="w-full"
          >
            Criar Ticket
          </Button>
        </div>
      </div>
    </Accordion>
  );
};

export const DataOS = ({
  ServiceOrder,
  goToInteractions,
  saveOs,
  goToConfirm,
  showInteractions,
  backToSearchPage,
}: DataOSProps) => {
  const orders = Array.isArray(ServiceOrder) ? ServiceOrder : [ServiceOrder];
  return (
    <div className="pb-[20px]">
      {orders.map((os) =>
        renderSingleOrder(
          os,
          goToInteractions,
          saveOs,
          goToConfirm,
          showInteractions,
          backToSearchPage
        )
      )}
    </div>
  );
};
